import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedService } from '@services/shared/shared.service';
import { ToastrService } from 'ngx-toastr';
import { initGlobalToastr } from './utils/toast-utils';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  constructor(public shared: SharedService, private toastService: ToastrService) {
    // Inicializa o serviço de toast global
    initGlobalToastr(toastService);
  }

  ngOnInit() {
    this.verifyDeviceContext();
  }

  @HostListener('window:resize')
  verifyDeviceContext() {
    const breakpoint = 768; //768px is the breakpoint for mobile devices [md size for Tailwind]
    const web = window.innerWidth >= breakpoint;
    if (web !== this.shared.web) {
      this.shared.mobileMenuIsOpen = false;
    }
    this.shared.web = web;
  }
}
